import { Component } from "react";
import { Routes, Route } from "react-router";
import { PackListingsSegments } from "../../features/Licensing/Packs/Listings";
import { CreatePack, EditPack } from "../../features/Licensing/Packs";
import { PacksOwnership } from "../../enums";
import NotFoundMessage from "../../components/notFound/NotFoundMessage";
import PacksOverviewSegments from "../../features/Licensing/Packs/Overview/PacksOverviewSegments";
import PackPurchasedViewSegments from "../../features/Licensing/Packs/PurchasedView/PackPurchasedViewSegments";
import { catchAll } from "utils/routeHelpers";
import { addContentToPackPermissions } from "enums/rights";
import { RestrictedResource } from "../../components";

class PacksContent extends Component {
  renderCreateEditPack = (isCreate, permissions) => {
    return (
      <RestrictedResource permissions={permissions}>{isCreate ? <CreatePack /> : <EditPack />}</RestrictedResource>
    );
  };

  render() {
    return (
      <div className="route-content-container">
        <Routes>
          <Route path="packs">
            <Route index element={<PacksOverviewSegments ownership={PacksOwnership.Own} />} />
            <Route path="available" element={<PacksOverviewSegments ownership={PacksOwnership.Available} />} />
            <Route path="create" element={this.renderCreateEditPack(true, addContentToPackPermissions)} />

            {catchAll("listings/:id", <PackListingsSegments />)}
            {catchAll("purchased/:id", <PackPurchasedViewSegments />)}

            {catchAll(":id", this.renderCreateEditPack(false, addContentToPackPermissions))}
          </Route>

          <Route path="*" element={<NotFoundMessage />} />
        </Routes>
      </div>
    );
  }
}

export default PacksContent;
